import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { API } from '@/utils/api.utils';
import api from '@/utils/api.utils';
import { Deadline } from '../index';

export const useDeadlinesData = () => {
  // In a real app, this would fetch from an API
  // For now, we'll provide mock data based on the reference
  const { data: universitiesData, isLoading: universitiesLoading, error } = useQuery({
    queryKey: ['user-universities'],
    queryFn: async () => {
      const response = await api.get(API.USER_UNIVERSITIES);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
  });

  const deadlines: Deadline[] = useMemo(() => {
    // Mock data based on the reference design
    return [
      {
        id: '1',
        name: 'Stanford University',
        type: 'application',
        description: 'Regular Decision Application - Common Application Portal',
        dueDate: '2025-01-05',
        dueTime: '23:59',
        status: 'in_progress',
        progress: 85,
        estimatedTimeHours: 3.5,
        priority: 'high',
        daysLeft: 7,
      },
      {
        id: '2',
        name: 'Gates Scholarship',
        type: 'scholarship',
        description: 'Full scholarship for minority students - $300,000 total value',
        dueDate: '2025-01-05',
        dueTime: '23:59',
        status: 'in_progress',
        progress: 40,
        estimatedTimeHours: 8,
        priority: 'high',
        daysLeft: 7,
      },
      {
        id: '3',
        name: 'Harvard University',
        type: 'application',
        description: 'Regular Decision Application - Coalition Application Portal',
        dueDate: '2025-01-10',
        dueTime: '23:59',
        status: 'in_progress',
        progress: 70,
        estimatedTimeHours: 4.5,
        priority: 'high',
        daysLeft: 12,
      },
      {
        id: '4',
        name: 'MIT',
        type: 'application',
        description: 'Early Action Application - MIT Application Portal',
        dueDate: '2025-01-15',
        dueTime: '23:59',
        status: 'in_progress',
        progress: 75,
        estimatedTimeHours: 3,
        priority: 'high',
        daysLeft: 17,
      },
      {
        id: '5',
        name: 'Summer Research Program',
        type: 'opportunity',
        description: 'Stanford Summer Research Program - 8 weeks paid internship',
        dueDate: '2025-01-15',
        dueTime: '23:59',
        status: 'not_started',
        progress: 0,
        estimatedTimeHours: 6,
        priority: 'medium',
        daysLeft: 17,
      },
      {
        id: '6',
        name: 'Coca-Cola Scholars Foundation',
        type: 'scholarship',
        description: '$20,000 scholarship for high-achieving students - Renewable annually',
        dueDate: '2025-01-20',
        dueTime: '23:59',
        status: 'in_progress',
        progress: 60,
        estimatedTimeHours: 5,
        priority: 'medium',
        daysLeft: 22,
      },
      {
        id: '7',
        name: 'FAFSA Priority Deadline',
        type: 'opportunity',
        description: 'Priority deadline for maximum financial aid consideration',
        dueDate: '2025-01-31',
        dueTime: '23:59',
        status: 'in_progress',
        progress: 90,
        estimatedTimeHours: 1,
        priority: 'high',
        daysLeft: 33,
      },
      {
        id: '8',
        name: 'UC Berkeley',
        type: 'application',
        description: 'Personal Insight Questions Due',
        dueDate: '2025-02-01',
        dueTime: '23:59',
        status: 'in_progress',
        progress: 40,
        estimatedTimeHours: 6,
        priority: 'medium',
        daysLeft: 34,
      },
    ];
  }, []);

  return {
    deadlines,
    isLoading: universitiesLoading,
    error,
  };
};